import { connect } from 'react-redux';

import { openPdfViewer } from '../actions/dashboardActions';
import { getShowPdfViewer } from '../components/Dashboard/dashboardSelectors';
import PdfViewer from '../components/PdfViewer/PdfViewerView';
import {
  getPdfLink,
  getQuestionSelector,
  isLoadingPdfLink,
} from '../components/Study/studyMainSelectors';

const mapStateToProps = (state, ownProps) => ({
  showPdfViewer: getShowPdfViewer(state),
  question: getQuestionSelector(state),
  pdfLink: getPdfLink(state),
  isLoadingPdfLink: isLoadingPdfLink(state),
});

const mapDispatchToProps = (dispatch) => ({
  openPdfViewer: (value) => dispatch(openPdfViewer(value)),
});

const PdfViewerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PdfViewer);

export default PdfViewerContainer;
